// Configuracao e tabelas do ClawETF, mais duas funcoes puras.
// Saiu do topo do App.js em 03/11/2026, inteiro e na mesma ordem:
// INDEX_PERIODS deriva de PERIODS, e APP_TABS dos tres arrays de aba.
// Nada aqui le estado do App — recebe tudo por argumento ou e dado.

export const API_URL = "https://etf-api-production-093e.up.railway.app"


export const CLAUDE_MODEL = "claude-sonnet-4-6"
// Chave Demo da CoinGecko. Fica exposta no bundle: e plano gratuito e
// solucao temporaria enquanto o Railway nao aceita deploy — o lugar
// certo dela e a variavel COINGECKO_API_KEY do etf-api.
export const CG_KEY = "CG-Jw6GzXmbAcEv5SuMD1gAexFP"
export const PRICE_USD = "price_1TL6h8EI3sFAnSqxYOoa00gM"
export const PRICE_BRL = "price_1TL6fYEI3sFAnSqxsAmu23Xj"
export const PRICE2_USD = "price_1TLPKlEI3sFAnSqxCzEAJ8iL"
export const PRICE2_BRL = "price_1TLPSAEI3sFAnSqxJF2X4PN5"

// media aritmetica, ou null com array vazio. Estava definida
// CINCO vezes dentro do componente, identica nas cinco, nos
// blocos que medem acerto de score. Se uma delas mudasse, dois
// cards de acerto passariam a calcular a media de formas
// diferentes sobre os mesmos dados. Unificada em 10/10/2026.
export const media = a => a.length ? a.reduce((s, x) => s + x, 0) / a.length : null
export const PRICE3_USD = "price_1TLjV7EI3sFAnSqx4ArgAnHs"
export const PRICE3_BRL = "price_1TLjS7EI3sFAnSqxslq8xYbb"
export const PRICE4_USD = "price_1TX47qEI3sFAnSqxee5EKIjy"
export const PRICE4_BRL = "price_1TX48tEI3sFAnSqx9dj3cXCI"
export const PRICE5_USD = "price_1TuWxuEI3sFAnSqxajWdGymA"
export const PRICE5_BRL = "price_1TuWuAEI3sFAnSqxZS9xp1Vv"

export const ETF_LIST = [
  "IBIT","FBTC","BITB","ARKB","GBTC","BTCO","HODL","EZBC","MSBT",
  "ETHA","FETH","ETHW","ETHE","ETH",
  "BSOL","XRPR","GXRP","TOXR",
  "GDLC","NCIQ","TDOT","HBR","LTCC","DOJE"
]

export const PERIODS = [
  {label:"1D",value:"1d"},{label:"5D",value:"5d"},{label:"1M",value:"1mo"},
  {label:"3M",value:"3mo"},{label:"YTD",value:"ytd"},{label:"1A",value:"1y"},
  {label:"5A",value:"5y"},{label:"MAX",value:"max"}
]
export const INDEX_PERIOD_LABELS = { "1y": "1Y", "5y": "5Y" }
export const INDEX_PERIODS = PERIODS.map(period => ({
  ...period,
  label: INDEX_PERIOD_LABELS[period.value] || period.label
}))
export const INDEX_SIMPLE_KEYS = ["SP500","NASDAQ","IBOVESPA","CAC40","DOW","FTSE100","DAX","EUROSTOXX50","NIKKEI225","HANGSENG","SHANGHAI","KOSPI","ASX200","NIFTY50","SENSEX","TSX"]
export const INDEX_SIMPLE_NAMES = {SP500:"S&P 500", NASDAQ:"NASDAQ", IBOVESPA:"Ibovespa", CAC40:"CAC 40", DOW:"Dow Jones", FTSE100:"FTSE 100", DAX:"DAX", EUROSTOXX50:"Euro Stoxx 50", NIKKEI225:"Nikkei 225", HANGSENG:"Hang Seng", SHANGHAI:"Shanghai", KOSPI:"KOSPI", ASX200:"ASX 200", NIFTY50:"Nifty 50", SENSEX:"Sensex", TSX:"TSX"}
export const INDEX_SIMPLE_TICKERS = {SP500:"^GSPC", NASDAQ:"^IXIC", IBOVESPA:"^BVSP", CAC40:"^FCHI", DOW:"^DJI", FTSE100:"^FTSE", DAX:"^GDAXI", EUROSTOXX50:"^STOXX50E", NIKKEI225:"^N225", HANGSENG:"^HSI", SHANGHAI:"000001.SS", KOSPI:"^KS11", ASX200:"^AXJO", NIFTY50:"^NSEI", SENSEX:"^BSESN", TSX:"^GSPTSE"}
export const INDEX_SIMPLE_CURRENCIES = {SP500:"$", NASDAQ:"$", IBOVESPA:"R$", CAC40:"€", DOW:"$", FTSE100:"£", DAX:"€", EUROSTOXX50:"€", NIKKEI225:"¥", HANGSENG:"HK$", SHANGHAI:"¥", KOSPI:"₩", ASX200:"A$", NIFTY50:"₹", SENSEX:"₹", TSX:"C$"}
export const INDEX_SIMPLE_API_KEYS = {SP500:"SP500", NASDAQ:"NASDAQ", IBOVESPA:"IBOVESPA", CAC40:"CAC40", DOW:"DOWJONES", FTSE100:"FTSE100", DAX:"DAX", EUROSTOXX50:"EUROSTOXX50", NIKKEI225:"NIKKEI225", HANGSENG:"HANGSENG", SHANGHAI:"SSE_COMPOSITE", KOSPI:"KOSPI", ASX200:"ASX200", NIFTY50:"NIFTY50", SENSEX:"SENSEX", TSX:"TSX_COMPOSITE"}
export const FUTURES_KEYS = ["SP500_FUT","NASDAQ_FUT","DOW_FUT"]
export const FUTURES_NAMES = {SP500_FUT:"S&P 500 Fut", NASDAQ_FUT:"NASDAQ 100 Fut", DOW_FUT:"Dow Jones Fut"}
export const FUTURES_TICKERS = {SP500_FUT:"ES=F", NASDAQ_FUT:"NQ=F", DOW_FUT:"YM=F"}
export const FUTURES_CURRENCIES = {SP500_FUT:"$", NASDAQ_FUT:"$", DOW_FUT:"$"}
export const FUTURES_API_KEYS = {SP500_FUT:"SP500_FUTURES", NASDAQ_FUT:"NASDAQ_FUTURES", DOW_FUT:"DOW_FUTURES"}
export const MARKET_OPEN_MINUTES_ET = 9 * 60 + 30
export const MARKET_CLOSE_MINUTES_ET = 16 * 60
export const ACTIVE_TAB_STORAGE_KEY = "activeTab"
export const PRIMARY_TABS = ["portfolio","grafico","adicionar","mercado"]
export const SECONDARY_TABS = ["indices","premium","vs","crypto","spot"]
export const ADVANCED_TABS = ["premium2","premium3","premium4","openclaw"]
export const APP_TABS = new Set([...PRIMARY_TABS, ...SECONDARY_TABS, ...ADVANCED_TABS])
// Nome escrito de cada aba, para o menu. Fica do lado dos ids de proposito:
// emoji sozinho no topo nao diz o que a aba e, e o menu vira a legenda disso.
export const MENU_ABAS = [
  ["portfolio", "\u{1F4CA}", "Carteira"],
  ["grafico", "\u{1F4C8}", "Patrim\u00f4nio"],
  ["adicionar", "\u2795", "Adicionar posi\u00e7\u00e3o"],
  ["mercado", "\u{1F310}", "Mercado ao vivo"],
  ["indices", "\u{1F3DB}\uFE0F", "\u00cdndices e macro"],
  ["premium", "\u2B50", "An\u00e1lise t\u00e9cnica"],
  ["vs", "\u2696\uFE0F", "Comparar ativos"],
  ["crypto", "\u20BF", "Cripto"],
  ["spot", "\u{1FA99}", "Carteira cripto"],
  ["premium2", "\u{1F48E}", "Risco da carteira"],
  ["premium3", "\u{1F9E0}", "An\u00e1lise completa"],
  ["premium4", "\u26A1", "Avan\u00e7ado e sinais"],
  ["openclaw", "\u{1F916}", "WhatsApp e Telegram"],
  ["premium5", "\u{1F9EC}", "Aportes e medi\u00e7\u00f5es"],
]
export const URL_POLITICA = "https://eduardo010470.github.io/clawetf-privacy/"

export function regimeDe(lista) {
  const _dc = (lista || []).slice().sort((a, b) => a - b)
  const _n = _dc.length
  if (_n === 0) return "NEUTRO"
  const _med = _n % 2 ? _dc[(_n - 1) / 2] : (_dc[_n / 2 - 1] + _dc[_n / 2]) / 2
  const _pos = _dc.filter(x => x > 0).length
  if (Math.round(Math.abs(_pos / _n * 100 - 50) * 2) < 40 || Math.abs(_med) < 0.2) return "NEUTRO"
  return _med > 0 ? "RISK-ON" : "RISK-OFF"
}
